<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14PUyyw/tc-custom/9780226016511.jpg?1736393107931" alt="This image is the cover for the book Deep Rhetoric"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deep Rhetoric
      </h1>
      <p class="bookDescription body article font2">
        <p>“Rhetoric is the counterpart of logic,” claimed Aristotle. “Rhetoric is the first part of logic rightly understood,” Martin Heidegger concurred. “Rhetoric is the universal form of human communication,” opined Hans-Georg Gadamer. But in <i>Deep Rhetoric</i>, James Crosswhite offers a groundbreaking new conception of rhetoric, one that builds a definitive case for an understanding of the discipline as a philosophical enterprise beyond basic argumentation and is fully conversant with the advances of the New Rhetoric of Chaïm Perelman and Lucie Olbrechts-Tyteca.<br/> Chapter by chapter, <i>Deep Rhetoric</i> develops an understanding of rhetoric not only in its philosophical dimension but also as a means of guiding and conducting conflicts, achieving justice, and understanding the human condition. Along the way, Crosswhite restores the traditional dignity and importance of the discipline and illuminates the twentieth-century resurgence of rhetoric among philosophers, as well as the role that rhetoric can play in future discussions of ontology, epistemology, and ethics. At a time when the fields of philosophy and rhetoric have diverged, Crosswhite returns them to their common moorings and shows us an invigorating new way forward.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Crosswhite
      </h2>
      
      <p class="authorDescription body article"><B>James Crosswhite</B> is associate professor of English at the University of Oregon. He is the author of <I>The Rhetoric of Reason</I>, and has directed writing programs at the University of California, San Diego, and at the University of Oregon, where he founded the Program in Writing, Speaking, and Critical Reasoning.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f3c8aa70